module.exports = __webpack_public_path__ + "static/media/scooter.d737faa6.svg";